import { OrgId } from 'app/common/types/id'
import { getBuildings } from 'app/dataProviders/buildings'

let buildingsAbortController: AbortController | undefined
export const getFilterBuildings = async (orgId: OrgId) => {
  buildingsAbortController?.abort()
  buildingsAbortController = new AbortController()
  const buildings = await getBuildings({ orgId }, buildingsAbortController?.signal)
  if (buildings) {
    return buildings
  }
  return []
}
